import 'jquery';


export class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}

export class Size {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }

    get w() {
        return this.width;
    }

    get h() {
        return this.height;
    }
}

let _utilsInstance = null;
export class Utils {
    constructor() {
        if(!_utilsInstance){
            _utilsInstance = this;
        }
        return _utilsInstance;
    }

    /**
     *
     * @returns {Utils}
     */
    static shared() {
        if (_utilsInstance) {
            return _utilsInstance;
        } else {
            return new Utils();
        }
    }

    /**
     *
     * @returns {jQuery}
     */
    window() {
        if (!this._window) {
            this._window = $(window);
        }

        return this._window;
    }
}


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/core/utils.js
 **/